import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgClickConfirmPlugin, SgClickConfirmOptions } from './types';
import { SgClickConfirmPluginHost, SG_CLICK_CONFIRM_DEFAULTS } from './click-confirm.service';
import { SgClickConfirmDirective } from './click-confirm.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SgClickConfirmDirective],
  exports: [SgClickConfirmDirective],
})
export class SgClickConfirmModule {
  static forRoot(defaultOptions: SgClickConfirmOptions): ModuleWithProviders<SgClickConfirmModule> {
    return {
      ngModule: SgClickConfirmModule,
      providers: [{ provide: SG_CLICK_CONFIRM_DEFAULTS, useValue: defaultOptions }, SgClickConfirmPluginHost],
    };
  }
}
